import React, { Component } from "react";
import _ from "lodash";
import { Table, Icon, Image } from "semantic-ui-react";
import PersonAvatar from "../../assets/images/PersonAvatar.jpg";

class PiplRecord extends Component {
  getNames = (props) => {
    const names = _.get(props.node, "names[0].name");
    if(!names) return null;
    let nameStr = "";
    _.forEach(names, (personName) => {
      if(nameStr === "") nameStr = _.get(personName, "display[0]._");
      else nameStr = `${nameStr}, ${_.get(personName, "display[0]._")}`;
    });
    return (
          <Table key={`names_${props.index}`}>
            <Table.Body>
              <Table.Row className={"report-sub-section-header"}>
                <Table.Cell className={"icon-align-middle padding-10"}>
                  Names
                </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>
                    {nameStr}
                  </Table.Cell>
                </Table.Row>
                {/* {rows} */}
            </Table.Body>
          </Table>
    );
  }

  getPersonHeader = (props) => {
    const names = _.get(props.node, "names[0].name");
    if(!names) return null;
    let nameStr = "";
    _.forEach(names, (personName) => {
      if(nameStr === "") nameStr = _.get(personName, "display[0]._");
      else nameStr = `${nameStr}, ${_.get(personName, "display[0]._")}`;
    });
    const imagePath = _.get(props.node, "images[0].image[0].url[0]._");
    const dob = _.get(props.node, "dob[0].display[0]._");
    const gender = _.get(props.node, "gender[0].content[0]._");
    return (
          <Table key={`personHeader_${props.index}`}>
            <Table.Body>
              <Table.Row className="report-sub-section-header">
                <Table.Cell colSpan={4}>
                  Person Details
                </Table.Cell>
              </Table.Row>

              <Table.Row>
                <Table.Cell colSpan={3} className="icon-align-middle padding-10">
                  {nameStr}
                </Table.Cell>

                <Table.Cell rowSpan={2} textAlign="center">
                  
                  {!imagePath ? (
                    <span>
                    <strong>Photo:</strong>
                  <br />
                    NA</span>
                  ) : (
                    <Image src={imagePath} size="small" floated="right" 
                      onError={(e) => {
                        e.target.onerror = null; // Prevent infinite loop
                        e.target.src = PersonAvatar;
                      }} />
                  )}
                </Table.Cell>
              </Table.Row>

              <Table.Row>
                <Table.Cell>
                  <strong>DOB/Age:</strong> {!dob ? "NA" : dob}
                </Table.Cell>

                <Table.Cell>
                  <strong>Gender:</strong> {!gender ? "NA" : gender}
                </Table.Cell>

                <Table.Cell>
                  <strong>Sources Available:</strong> {!props.availableSources ? "NA" : props.availableSources}
                </Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>
    );
  }

  getDob = (props) => {
    const dob = _.get(props.node, "dob[0].display[0]._");
    if(!dob) return null;
    return (
          <Table key={`dob_${props.index}`}>
            <Table.Body>
              <Table.Row className={"report-sub-section-header"}>
                <Table.Cell className={"icon-align-middle padding-10"}>
                  DOB/Age
                </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>
                    {dob}
                  </Table.Cell>
                </Table.Row>
            </Table.Body>
          </Table>
    );
  }

  getGender = (props) => {
    const gender = _.get(props.node, "gender[0].display[0]._");
    if(!gender) return null;
    return (
          <Table key={`gender_${props.index}`}>
            <Table.Body>
              <Table.Row className={"report-sub-section-header"}>
                <Table.Cell className={"icon-align-middle padding-10"}>
                  Gender
                </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>
                    {gender}
                  </Table.Cell>
                </Table.Row>
            </Table.Body>
          </Table>
    );
  }

  getUserNames = (props) => {
    const userNames = _.get(props.node, "userNames[0].userName");
    if(!userNames) return null;
    const rows = [];
    _.forEach(userNames, (userName, index) => {
      const colorClass = index % 2 === 0 ? "odd-row" : "even-row";
      rows.push(<Table.Row key={`username_${props.index}_${index}`} className={colorClass}>
        <Table.Cell>{_.get(userName, "content[0]._")}</Table.Cell>
      </Table.Row>)
    });
    return (
          <Table key={`usernames_${props.index}`}>
            <Table.Body>
              <Table.Row className={"report-sub-section-header"}>
                <Table.Cell className={"icon-align-middle padding-10"}>
                  User Names
                </Table.Cell>
                </Table.Row>
                {rows}
            </Table.Body>
          </Table>
    );
  }

  getEmails = (props) => {
    const emails = _.get(props.node, "emails[0].email");
    if(!emails) return null;
    const rows = [];
    _.forEach(emails, (email, index) => {
      const colorClass = index % 2 === 0 ? "odd-row" : "even-row";
      const emailType = _.get(email, "type[0]._");
      rows.push(<Table.Row key={`email_${props.index}_${index}`} className={colorClass}>
        <Table.Cell>{_.get(email, "address[0]._")}
          {emailType && (<span className="padding-left-5">({emailType})</span>)}
        </Table.Cell>
      </Table.Row>)
    });
    return (
          <Table key={`emails_${props.index}`}>
            <Table.Body>
              <Table.Row className={"report-sub-section-header"}>
                <Table.Cell className={"icon-align-middle padding-10"}>
                  Emails
                </Table.Cell>
                </Table.Row>
                {rows}
            </Table.Body>
          </Table>
    );
  }

  getPhoneIcon = (phoneType) => {
    switch(phoneType) {
      case "mobile":
        return (<span className="padding-left-5"><Icon name="mobile" color="red" size="small" /></span>);
      case "work_phone":
        return (<span className="padding-left-5"><Icon name="phone" color="red" size="small" /></span>);
      default:
        return null;
    }
  }

  getPhones = (props) => {
    const phones = _.get(props.node, "phones[0].phone");
    if(!phones) return null;
    const rows = [];
    _.forEach(phones, (phone, index) => {
      const colorClass = index % 2 === 0 ? "odd-row" : "even-row";
      const phoneType = _.get(phone, "type[0]._");

      rows.push(<Table.Row key={`phone_${props.index}_${index}`} className={colorClass}>
        <Table.Cell>{_.get(phone, "display_international[0]._")}{this.getPhoneIcon(phoneType)}</Table.Cell>
      </Table.Row>)
    });
    return (
          <Table key={`phones_${props.index}`}>
            <Table.Body>
              <Table.Row className={"report-sub-section-header"}>
                <Table.Cell className={"icon-align-middle padding-10"}>
                  Phones
                </Table.Cell>
                </Table.Row>
                {rows}
            </Table.Body>
          </Table>
    );
  }

  getAddresses = (props) => {
    const addresses = _.get(props.node, "addresses[0].address");
    if(!addresses) return null;
    const rows = [];
    _.forEach(addresses, (address, index) => {
      const colorClass = index % 2 === 0 ? "odd-row" : "even-row";
      rows.push(<Table.Row key={`address_${props.index}_${index}`} className={colorClass}>
        <Table.Cell>{_.get(address, "display[0]._")}</Table.Cell>
      </Table.Row>)
    });
    return (
          <Table key={`addresses_${props.index}`}>
            <Table.Body>
              <Table.Row className={"report-sub-section-header"}>
                <Table.Cell className={"icon-align-middle padding-10"}>
                  Addresses
                </Table.Cell>
                </Table.Row>
                {rows}
            </Table.Body>
          </Table>
    );
  }

  getEducations = (props) => {
    const userNames = _.get(props.node, "educations[0].education");
    if(!userNames) return null;
    const rows = [];
    _.forEach(userNames, (userName, index) => {
      const colorClass = index % 2 === 0 ? "odd-row" : "even-row";
      rows.push(<Table.Row key={`education_${props.index}_${index}`} className={colorClass}>
        <Table.Cell>{_.get(userName, "display[0]._")}</Table.Cell>
      </Table.Row>)
    });
    return (
          <Table key={`educations_${props.index}`}>
            <Table.Body>
              <Table.Row className={"report-sub-section-header"}>
                <Table.Cell className={"icon-align-middle padding-10"}>
                  Educations
                </Table.Cell>
                </Table.Row>
                {rows}
            </Table.Body>
          </Table>
    );
  }

  getUserIds = (props) => {
    const userIds = _.get(props.node, "user_ids[0].user_id");
    if(!userIds) return null;
    const rows = [];
    _.forEach(userIds, (userId, index) => {
      const colorClass = index % 2 === 0 ? "odd-row" : "even-row";
      rows.push(<Table.Row key={`userId_${props.index}_${index}`} className={colorClass}>
        <Table.Cell>{_.get(userId, "content[0]._")}</Table.Cell>
      </Table.Row>)
    });
    return (
          <Table key={`userIds_${props.index}`}>
            <Table.Body>
              <Table.Row className={"report-sub-section-header"}>
                <Table.Cell className={"icon-align-middle padding-10"}>
                  User Ids
                </Table.Cell>
                </Table.Row>
                {rows}
            </Table.Body>
          </Table>
    );
  }

  getJobs = (props) => {
    const jobs = _.get(props.node, "jobs[0].job");
    if(!jobs) return null;
    const rows = [];
    _.forEach(jobs, (job, index) => {
      const colorClass = index % 2 === 0 ? "odd-row" : "even-row";
      rows.push(<Table.Row key={`job_${props.index}_${index}`} className={colorClass}>
        <Table.Cell>{_.get(job, "display[0]._")}</Table.Cell>
        <Table.Cell>{_.get(job, "industry[0]._", "")}</Table.Cell>
      </Table.Row>)
    });
    return (
          <Table key={`jobs_${props.index}`}>
            <Table.Body>
              <Table.Row className={"report-sub-section-header"}>
                <Table.Cell className={"icon-align-middle padding-10"} colSpan={2}>
                  Jobs
                </Table.Cell>
                </Table.Row>
              <Table.Row className={"result-header"}>
                <Table.Cell className={"icon-align-middle padding-10"}>
                  Job
                </Table.Cell>
                <Table.Cell className={"icon-align-middle padding-10"}>
                  Industry
                </Table.Cell>
                </Table.Row>
                {rows}
            </Table.Body>
          </Table>
    );
  }

  getVehicles = (props) => {
    const vehicles = _.get(props.node, "vehicles[0].vehicle");
    if(!vehicles) return null;
    const rows = [];
    _.forEach(vehicles, (vehicle, index) => {
      const colorClass = index % 2 === 0 ? "odd-row" : "even-row";
      rows.push(<Table.Row key={`vehicle_${props.index}_${index}`} className={colorClass}>
        <Table.Cell>{_.get(vehicle, "display[0]._")}</Table.Cell>
      </Table.Row>)
    });
    return (
          <Table key={`vehicles_${props.index}`}>
            <Table.Body>
              <Table.Row className={"report-sub-section-header"}>
                <Table.Cell className={"icon-align-middle padding-10"} colSpan={2}>
                  Vehicles
                </Table.Cell>
                </Table.Row>
                {rows}
            </Table.Body>
          </Table>
    );
  }

  getRelationships = (props) => {
    const relationships = _.get(props.node, "relationships[0].relationship");
    if(!relationships) return null;
    const rows = [];
    _.forEach(relationships, (relationship, index) => {
      const colorClass = index % 2 === 0 ? "odd-row" : "even-row";
      const names = _.get(relationship, "names[0].name");
      let nameStr = "";
      _.forEach(names, (personName) => {
        if(nameStr === "") nameStr = _.get(personName, "display[0]._");
        else nameStr = `${nameStr}, ${_.get(personName, "display[0]._")}`;
      });
      const type = _.get(relationship, "type[0]._", "");
      const subType = _.get(relationship, "subType[0]._");
      rows.push(<Table.Row key={`relationship_${props.index}_${index}`} className={colorClass}>
        <Table.Cell>{type}{subType && ` - ${subType}`}</Table.Cell>
        <Table.Cell>{nameStr}</Table.Cell>
      </Table.Row>);
    });
    return (
          <Table key={`relationships_${props.index}`}>
            <Table.Body>
              <Table.Row className={"report-sub-section-header"}>
                <Table.Cell className={"icon-align-middle padding-10"} colSpan={2}>
                  Relationships
                </Table.Cell>
                </Table.Row>
              <Table.Row className={"result-header"}>
                <Table.Cell className={"icon-align-middle padding-10"}>
                  Relationship
                </Table.Cell>
                <Table.Cell className={"icon-align-middle padding-10"}>
                  Names
                </Table.Cell>
                </Table.Row>
                {rows}
            </Table.Body>
          </Table>
    );
  }

  getUrls = (props) => {
    const urls = _.get(props.node, "urls[0].url");
    if(!urls) return null;
    const rows = [];
    _.forEach(urls, (url, index) => {
      const colorClass = index % 2 === 0 ? "odd-row" : "even-row";
      const nameOrDomain = _.get(url, "name[0]._") || _.get(url, "domain[0]._");
      rows.push(<Table.Row key={`url_${props.index}_${index}`} className={colorClass}>
        <Table.Cell><a
              href={_.get(url, "url[0]._")}
              alt="Social media URL"
              target="_blank"
              rel="noopener noreferrer"
            >{_.get(url, "url[0]._")}</a></Table.Cell>
        <Table.Cell>{nameOrDomain}</Table.Cell>
      </Table.Row>)
    });
    return (
          <Table key={`urls_${props.index}`}>
            <Table.Body>
              <Table.Row className={"report-sub-section-header"}>
                <Table.Cell className={"icon-align-middle padding-10"} colSpan={2}>
                  Social Media
                </Table.Cell>
                </Table.Row>
              <Table.Row className={"result-header"}>
                <Table.Cell className={"icon-align-middle padding-10"}>
                  Url
                </Table.Cell>
                <Table.Cell className={"icon-align-middle padding-10"}>
                  Platform
                </Table.Cell>
                </Table.Row>
                {rows}
            </Table.Body>
          </Table>
    );
  }

  render() {
    if(this.props.reportRoot === "emailreps") {
      return (<div>
        {this.getPersonHeader(this.props)}
        {this.getEmails(this.props)}
      </div>);
    }
    return (<div>
      {this.getPersonHeader(this.props)}
      {this.getUserNames(this.props)}
      {this.getUrls(this.props)}
    </div>);
  }
}

export default PiplRecord;



// WEBPACK FOOTER //
// ./src/components/reports/PiplRecord.js